import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import  PainelTV1  from "../PainelTV1";
import PainelTVLogo from "../PainelTVLogo";
import PainelTVProducaoSolTipler from "../PainelTVProducao";
import PainelTVSLA from "../PainelTVSLA";
import PainelTVProducaoMensal from "../PainelTVProducaoMensal";
import PainelTVMetasMes from "../PainelTVMetasMes";
import PainelTVOperadores from "../PainelTVOperadores";
import {useSelector} from "react-redux";


const useStyles = makeStyles(theme => ({
    mainGrid:{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap'

    },
    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
        marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
        marginBottom: theme.spacing(1) * 5,
    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
        paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
}));

const PainelTV = (props) => {
    const { setTitulo, setLimite } = props;
    const classes = useStyles();
    const [paginaAtual,setPaginaAtual] = useState(2);
    const [contador,setContador] = useState(1);

    const mock = useSelector(state => state.i4.mock);


    useEffect(()=>{
        let tempoRefresh = 90;
        // switch (paginaAtual) {
        //     case 1:
        //         tempoRefresh = 5;
        //         break;
        // }
        props.setLimite(tempoRefresh);
        const interval=setInterval(()=>{
            setContador(contador +1);

            getPage()
        },tempoRefresh * 1000);
        return()=>clearInterval(interval)
    },[paginaAtual]);


    const getPage = () => {
        switch (paginaAtual) {
            case 6:
                setPaginaAtual(2);  // nao mostrar pagina do Logo
                break;
            default:
                let pa = paginaAtual+1;
                console.log("mock", mock);
                if (mock &&  ([3].includes(pa))) {
                    console.log("operadores, incrementa");
                    pa += 1;
                }
                setPaginaAtual(pa);

                break;
        }
    }

    return (
        <React.Fragment>
            <Grid container className={classes.mainGrid}>
                <Grid item container  xs={12} sm={12} lg={12} xl={12}>
                        { paginaAtual === 1 && <PainelTVLogo contador={contador} setTitulo={setTitulo}/> }
                        { paginaAtual === 2 && <PainelTV1 contador={contador} setTitulo={setTitulo}/> }
                        { paginaAtual === 3 && <PainelTVOperadores contador={contador} setTitulo={setTitulo}/> }
                        { paginaAtual === 4 && <PainelTVProducaoSolTipler contador={contador} setTitulo={setTitulo}/> }
                        { paginaAtual === 5 && <PainelTVProducaoMensal contador={contador} setTitulo={setTitulo}/> }
                        { paginaAtual === 6 && <PainelTVMetasMes contador={contador} setTitulo={setTitulo}/> }
                        { paginaAtual === 7 && <PainelTVSLA contador={contador} setTitulo={setTitulo}/> }

                </Grid>
            </Grid>
        </React.Fragment>
    )

}

export default PainelTV;
